/**
 * Weekly schedule flags shared by the portal Team Schedule and the desktop Schedule.
 * rows: [{ schedule_id, date, project_id, project_ref, employee_id, employee_name }]
 * team: [{ id, name }] — the people we expect to see scheduled this week.
 */
export function computeScheduleFlags(rows, team) {
  const projs = {};
  rows.forEach(r => { const k = `${r.date}|${r.employee_id}`; (projs[k] = projs[k] || new Set()).add(r.project_id); });
  const dupKeys = new Set(Object.keys(projs).filter(k => projs[k].size > 1));

  const seen = {};
  rows.forEach(r => {
    const k = `${r.date}|${r.employee_id}`;
    if (!dupKeys.has(k)) return;
    seen[k] = seen[k] || { date: r.date, id: r.employee_id, name: r.employee_name, refs: [] };
    if (!seen[k].refs.includes(r.project_ref)) seen[k].refs.push(r.project_ref);
  });
  const doubleBooked = Object.values(seen).sort((a, b) => a.date.localeCompare(b.date));

  const scheduledIds = new Set(rows.map(r => r.employee_id));
  const unscheduled = (team || []).filter(t => !scheduledIds.has(t.id));
  return { dupKeys, doubleBooked, scheduledIds, unscheduled };
}

/** Desktop `/schedules` rows carry `employees: [{id,name}]`; flatten to one row per person. */
export const flattenSchedules = (schedules) => (schedules || []).flatMap(s => (s.employees || []).map(e => ({
  schedule_id: s.id, date: s.date, project_id: s.project_id, project_ref: s.project_ref, employee_id: e.id, employee_name: e.name,
})));
